import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Button, Dialog, Illustration, Input2FA } from '@node-space/ui-components'
import { TWO_FACTOR_CODE_LENGTH } from 'constants/General'

interface RewardsEmbeddedDisburseDialogProps {
  open: boolean
  onClose: () => void
  onDisburse: (authenticationCode: string) => void
  otpError?: string
}

export const RewardsEmbeddedDisburseDialog = ({
  open,
  onClose,
  onDisburse,
  otpError,
}: RewardsEmbeddedDisburseDialogProps) => {
  const { t } = useTranslation()
  const [authenticationCode, setAuthenticationCode] = useState('')

  const handleAuthenticationCodeChange = (value: string) => {
    setAuthenticationCode(value)
  }

  const handleDisburse = () => {
    onDisburse(authenticationCode)
  }

  useEffect(() => {
    if (open) {
      setAuthenticationCode('')
    }
  }, [open])

  return (
    <Dialog
      type="alert"
      title={t('rewards.embeddedCustomers.disburseDialog.title')}
      Illustration={<Illustration name="Warning" />}
      open={open}
      onClose={onClose}
      ActionButtons={[
        <Button
          key="disburse"
          variant="primary"
          onClick={handleDisburse}
          disabled={authenticationCode.length !== TWO_FACTOR_CODE_LENGTH}
        >
          {t('confirm')}
        </Button>,
        <Button key="cancel" variant="secondary" onClick={onClose}>
          {t('cancel')}
        </Button>,
      ]}
    >
      <Box flexCol gapY={16}>
        <p className="text-center text-body-regular text-foreground-prominent">
          {t('rewards.embeddedCustomers.disburseDialog.description')}
        </p>
        <Input2FA
          label={t('rewards.embeddedCustomers.disburseDialog.authenticationCode')}
          onComplete={handleAuthenticationCodeChange}
          key={`authentication-code-${open}`}
          error={otpError}
        />
      </Box>
    </Dialog>
  )
}
